module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p4.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "recipe-ttile"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', {
    staticClass: "col6"
  }, [_vm._v("contents")])])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page7"
    }
  }, [_vm._v("introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02#page13"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_vm._v("drop cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2a"
  }, [_vm._v("shaped cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04#page45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col4a"
  }, [_vm._v("piped cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05#page55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col6a"
  }, [_vm._v("rolled & cut cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06#page71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col8"
  }, [_vm._v("brownies & bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col4"
  }, [_vm._v("fillings & coatings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#page93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shipping baked goods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09#page94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0